"use client";

import Footer from "@/components/footer/footer";
import { useData } from "./DataProvider";

export default function FooterWrapper() {
  const { services, about } = useData();
  return <Footer services={services} about={about} />;
}
